import React, { useEffect } from "react";
import PropTypes from "prop-types";
import ActionRequests from "../actionRequests/index.js";
import { ProductsTable } from "../productsTable/index.js";
import { Section } from "../reusableComponents/Section/index.js";

import { vendorPendingRequestsSelector } from "../../selectors/index.js";
import { useSelector, useDispatch } from "react-redux";
import {
  vendorDraftList,
  vendorPendingActionRequests,
  loadingActionRequests,
} from "../../actions/index.js";

const IsLoading = () => <Section title="Data Loading..." />;

export function DashBoard({ dataSelector }) {
  const dispatch = useDispatch();
  const data = useSelector(dataSelector);
  const actionRequestList = useSelector(vendorPendingRequestsSelector);

  useEffect(() => {
    dispatch(loadingActionRequests(true));
    dispatch(vendorDraftList(data));
    dispatch(vendorPendingActionRequests());
  }, []);

  return (
    <>
      <ActionRequests actions={actionRequestList} isBeingReviewed={false} />
      {data.length === 0 ? <IsLoading /> : <ProductsTable data={data} />}
    </>
  );
}

DashBoard.propTypes = {
  dataSelector: PropTypes.func,
};
